import { registerPlugin } from '@capacitor/core';

const iosAppNotifSettingPlugin = registerPlugin('AppNotificationSettingPlugin');

export default iosAppNotifSettingPlugin;
